// @flow
import styled from "styled-components";

import buildColor from "../../_static/ColorPalette";
import { fontNormal } from "../../_static/Typography";

export const RepeatCounter = styled.h1`
  display: flex;
  align-items: center;
  font-size: 52px;
  text-align: center;
  font-family: ${fontNormal};
  color: ${({ isDisabled, showWarning }) => {
    if (showWarning) {
      return buildColor("yellow", "700");
    }
    if (isDisabled) {
      return buildColor("blue_accent", "300");
    }
    return buildColor("blue_accent", "600");
  }};

  &::before {
    content: "x";
    font-size: 24px;
    font-weight: 500;
    color: ${({ showWarning }) =>
      showWarning
        ? buildColor("orange", "700")
        : buildColor("blue_accent", "600")};
  }
`;

export const RepeatBetDetails = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
`;

export const RepeatBetsContainer = styled.div`
  background: ${buildColor("white", "100")};
`;

export const RepeatButtonWrapper = styled.div`
  padding: 16px 12px 20px;
`;

export const SetToMaxWrapper = styled.div`
  margin-top: 4px;
  margin-bottom: 32px;
  display: flex;
  align-items: center;

  svg {
    margin-right: 5px;
  }
`;
